import React from 'react';
import styles from './FormAlert.module.scss';

function FormAlert({ variant = "danger", children, className = "" }) {
    if (!children) return null;

    const variantClass = variant === "success" ? styles.success : styles.danger;

    return (
        <div className={`${styles.alert} ${variantClass} ${className}`.trim()}>
            <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                {variant === "success" ? (
                    <>
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="8 12 11 15 16 9" />
                    </>
                ) : (
                    <>
                        <circle cx="12" cy="12" r="10" />
                        <line x1="12" y1="8" x2="12" y2="12" />
                        <line x1="12" y1="16" x2="12.01" y2="16" />
                    </>
                )}
            </svg>
            <span className={styles.text}>{children}</span>
        </div>
    );
}

export default FormAlert;
